import { useState, useEffect } from 'react'
import { FaRegCheckCircle, FaRegTimesCircle, FaRedo, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useProfileStore } from '../../store/useUserStore';

type Props = {}

const PaymentHistory = (props: Props) => {
    const navigate = useNavigate()
    const [histories, setHistories] = useState([])
    const { t } = useTranslation()

    const { setSelectedStudent, setLoading } = useProfileStore()

    useEffect(() => {
        getHistory()
        readOrderNotification()
    }, [])

    function getHistory() {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/order`).then(res => {
            setLoading(false)
            for (let result of res.data.result.data) {
                result["expaned"] = false
            }
            console.log("res history", res.data.result.data)
            setHistories(res.data.result.data)
        }).catch(err => {
            setLoading(false)
            console.log("err cart", err)
        })
    }
    
    function readOrderNotification() {
        // read order notification 
        api.post(`${process.env.PUBLIC_URL}/order/seen`).then(res => {
            console.log("res notif", res)
        }).catch(err =>{
            // toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    function getHistoryById(historyId: number) {
        // dispatch(setLoading(true))
        // api.get(`${process.env.REACT_APP_API_BASE_URL}/order/${historyId}`).then(res => {
        //     dispatch(setLoading(false))
        //     console.log("res historyId", res.data.data)
        //     // setHistories((prevHistories:any) => prevHistories.map((history:any) => history.id === historyId ? { ...history, expanded: !history.expanded, order_items: res.data.data.order_items } : { ...history, expanded: false } ) )
        setHistories((prevHistories:any) => prevHistories.map((history:any) => history.id === historyId ? { ...history, expanded: !history.expanded } : { ...history, expanded: false } ) )
        // }).catch(err => {
        //     dispatch(setLoading(false))
        //     console.log("err cart", err)
        // })
    }
    
    function repeatPayment(orderId: any) {
        var windowReference = window.open()
        console.log("repeatPayment", orderId)
        setLoading(true)
        api.post(`${process.env.PUBLIC_URL}/order/pay`, {
            order_id: orderId
        }).then(res => {
            setLoading(false)
            console.log("res", res)
            const paymentUrl = res.data.payment_url
            if (paymentUrl) {
                windowReference!.location = paymentUrl
            } else {
                toast.error(t("url_not_found"))
            }
        }).catch(err =>{
            setLoading(false)
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    const navigateBack = () => {
        if (window.history?.length && window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/profile', { replace: true })
        }
    }

    function navigateItem(item_id: number, course_branch_id:number, student_id:number, student_name:string) {
        setSelectedStudent({id: student_id , name: student_name})
        return navigate(`/item/${item_id}?course_branch_id=${course_branch_id}`)
    }

    function navigateCourseBranch(course_branch_id: number, student_id:number, student_name:string) {
        setSelectedStudent({id: student_id , name: student_name})
        return navigate(`/course/${course_branch_id}`)
    }

    return (
        <div className="pb-28">
            <div className='mb-2 grid grid-cols-4 px-2'>
                <div><IoIosArrowBack size={28} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='text-center col-span-2 text-lg font-medium'>{t('payment_history.payment_history')}</div>
                <div></div>
            </div>

            <div className="border-b border-gray-300 px-2">
                {histories.map((history: any) => {
                return (
                    <div className='shadow-course-card rounded-md'>
                    <div className="grid grid-cols-12 gap-4 items-center justify-between p-4 ">
                        <div className="col-span-3 lg:col-span-3 text-center text-white">
                            <div className={`p-1 rounded-xl text-sm ${history.status === 'paid' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`} >
                                {history.status === 'paid' ? t('payment_history.paid') : t('payment_history.unpaid')}
                            </div>
                        </div>
                        <div className="col-span-4 lg:col-span-3 text-lg font-medium">{history.purchased_date}</div>
                        <div className="col-span-4 lg:col-span-5 text-lg font-medium justify-self-end">RM {history.total_price}</div>
                        <button className="col-span-1 text-gray-500 hover:text-gray-700 transition justify-self-end" onClick={() => { getHistoryById(history.id) }}>
                            {history.expanded === true ? <FaChevronDown /> : <FaChevronRight />}
                        </button>
                    </div>

                    {(history.expanded && history.content.length > 0 && history.content.map((student: any) => (
                        <div className="px-4 border-b border-gray-300">
                        <div className='my-3 text-lg font-bold'>{student.student_name}</div>
                        {(student.items.length > 0 && student.items.map((item: any) => {
                            if (item.type == "course") {
                            return (
                                <div className="grid grid-cols-12 items-center mb-3 gap-2">
                                    <div onClick={()=>{navigateCourseBranch(item.course_branch_id, student.student_id, student.student_name)}} className="col-span-3 md:col-span-2 bg-gray-100 cursor-pointer">
                                        {item.course.images && item.course.images.length > 0 ? (
                                            <img className="w-full h-full object-cover" alt={t('payment_history.product')} src={item.course.images[0]} />
                                        ) : (
                                            <img className="w-full h-full object-cover" alt={t('payment_history.product')} src="/assets/img/products/product1.png"/>
                                        )}
                                    </div>

                                    <div className="col-span-6 md:col-span-8 flex flex-col justify-center space-y-1">
                                        <h3 onClick={()=>{navigateCourseBranch(item.course_branch_id, student.student_id, student.student_name)}} className="text-base font-medium truncate cursor-pointer">{item.course.name || "-"}</h3>
                                        <span className="text-base text-gray-600 truncate">{item.student || "-"}</span>
                                        <p className="text-base text-gray-600 break-words whitespace-normal">{item.selected_date || "-"}</p>
                                    </div>

                                    <div className="col-span-3 md:col-span-2 text-right">
                                        <p className="text-lg font-medium text-gray-700">RM {item.price || "-"}</p>
                                    </div>
                                </div>
                            )
                            } else if (item.type == "item") {
                            return (
                                <div className="grid grid-cols-12 items-center mb-3 gap-2">
                                    <div onClick={()=>{navigateItem(item.item.id, item.course_branch_id, student.student_id, student.student_name)}} className="col-span-3 md:col-span-2 bg-gray-100 cursor-pointer">
                                        {item.item.images && item.item.images.length > 0 ? (
                                            <img className="w-full h-full object-cover" alt={t('payment_history.product')} src={item.item.images[0]} />
                                        ) : (
                                            <img className="w-full h-full object-cover" alt={t('payment_history.product')} src="/assets/img/products/product1.png" />
                                        )}
                                    </div>

                                    <div className="col-span-6 md:col-span-8 flex flex-col justify-center space-y-1">
                                        <h3 onClick={()=>{navigateItem(item.item.id, item.course_branch_id, student.student_id, student.student_name)}} className="text-base font-medium truncate cursor-pointer" >{item.item.name || "-"}</h3>
                                        <span className="text-base text-gray-600">{item.student || "-"}</span>
                                        <div></div>
                                    </div>
                                    <div className="col-span-3 md:col-span-2 text-right">
                                        <p className="text-lg font-medium text-gray-700">RM {item.total_price || "-"}</p>
                                    </div>
                                </div>
                            )

                            }
                        }))}
                        </div>
                    )))}
                    {(history.expanded && (
                        <div className="px-4 py-4">
                            <div className='grid grid-cols-2 text-base mb-1'>
                                <div>{t('payment_history.payment_method')}</div>
                                <div className='text-end'>{history.payment_method || "-"}</div>
                            </div>
                        <div className='grid grid-cols-2 text-base mb-1'>
                            <div>{t('payment_history.payment_status')}</div>
                            <div className='text-end'>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</div>
                        </div>
                        <div className='grid grid-cols-2 text-base mb-1'>
                            <div>{t('payment_history.order_id')}</div>
                            <div className='text-end'>{history.order_id == "" || !history.order_id ? "-" : history.order_id}</div>
                        </div>
                        <div className='grid grid-cols-2 text-base mb-1'>
                            <div>{t('payment_history.payment_date')}</div>
                            <div className='text-end'>{history.purchased_date}</div>
                        </div>
                        <div className='grid grid-cols-2 text-lg mb-1'>
                            <div>{t('payment_history.total_amount')}</div>
                            <div className='text-end font-bold'>RM {history.total_price}</div>
                        </div>
                        {history.status != "paid" && (
                            <div className='mt-3 font-semibold flex justify-end'>
                            <div className='p-2 px-4 rounded-xl w-3/5 text-center' style={{ backgroundColor: '#f5ce00' }} onClick={() => { repeatPayment(history.id) }} > $ {t('payment_history.pay_now')} </div>
                            </div>
                        )}
                        </div>
                    ) )}
                    </div>
                )
                })}

            </div>
        </div>
    )
}

export default PaymentHistory